import React from "react"
import { firestoreConnect, isLoaded } from "react-redux-firebase"
import Presentation from "./Presentation"
import { compose } from "redux"
import { connect } from "react-redux"
import CircularSpinner from "../../../../../shared/circularSpinner"

function Container(props) {
  if (isLoaded(props.project))
    return (
      <div>
        <Presentation {...props} />
      </div>
    )
  return (
    <CircularSpinner />
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    employee: state.firebase.profile,
    project: state.firestore.ordered.project
      ? state.firestore.ordered.project[0]
      : state.firestore.ordered.projectsList.filter(
          (project) => project.id === ownProps.id
        )[0],
  }
}
export default compose(
   firestoreConnect((props) => {
    if (!props.project)
      return [
        {
          collection: "PROJECTS",
          doc: props.id,
          storeAs: "project",
        },
      ]
    return []
  }),
  connect(mapStateToProps)
 
)(Container)
